import "./App.css";
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { DynamicThemeProvider } from "./contexts/ThemeContext";
import AuthLayout from "./layouts.js/AuthLayout";
import AuthRegisterLayout from "./layouts.js/RegisterLayout";
import DashboardLayout from "./layouts.js/DashboardLayout";
import Login from "./pages/AuthPages/Login/Login";
import ForgetPassword from "./pages/AuthPages/Login/ForgetPassword";
import VerificationScreen from "./pages/AuthPages/Login/VerificationScreen";
import ResetPassword from "./pages/AuthPages/Login/Resetpassword";
import Registeration from "./pages/AuthPages/Registeration/Registeration";
import Location from "./pages/AuthPages/Registeration/Locations";
import CreateProfile from "./pages/AuthPages/Registeration/CreateProfile";
import Region from "./pages/AuthPages/Registeration/Region";
import AddressLocation from "./pages/AuthPages/Registeration/AddressLocation";
import CompanyDetails from "./pages/AuthPages/Registeration/CompanyDetails";
import FaceScanning from "./pages/AuthPages/Registeration/FaceScanning";
import Dashboard from "./pages/AdminPages/Dashboard/Dashboard";
import RegisterationVerification from "./pages/AuthPages/Registeration/RegisterationVerification";
import Messages from "./pages/AdminPages/Messages/Inbox/Inbox";
import Support from "./pages/AdminPages/Messages/Support/Support";
import PrivateRoute from "./Routes/PrivateRoutes";
import PublicRoute from "./Routes/PublicRoute";
import Notifications from "./pages/AdminPages/Notifications.js/Notifications";
// import Settings from './pages/AdminPages/Settings/Settings';
import Settings from "./pages/AdminPages/Settings/Settings";
import OTPScreen from "./pages/AuthPages/Registeration/OTPScreen";
import AllWorkers from "./pages/AdminPages/Worker/AllWorkers/AllWorkers";
import Departments from "./pages/AdminPages/Worker/Departments/Departments";
import AllTasks from "./pages/AdminPages/TaskManagement/AllTasks/AllTasks";
import CalendarTask from "./pages/AdminPages/TaskManagement/CalenderView/CalenderView";
import SalaryRecords from "./pages/AdminPages/ExpenseManagement/SalaryRecords/SalaryRecords";
import MessagesLayout from "./pages/AdminPages/Messages/MessagesLayout";

import ReportsandStatistics from "./pages/AdminPages/Report & Statistics/Reports&Statistics";
import Reports from "./pages/AdminPages/Reports/Reports";

import UnvalidatedPunches from "./pages/AdminPages/Attendance/UnvalidatedPunches/UnvalidatedPunches";
import TodaysLogs from "./pages/AdminPages/Attendance/TodaysLogs/TodaysLogs";

import AttendanceHistory from "./pages/AdminPages/Attendance/AttendanceHistory/AttendanceHistory";
import TaskAttendanceHistory from "./pages/AdminPages/TaskManagement/TaskAttendanceHistory/TaskAttendanceHistory";

import WorkerDocuments from "./pages/AdminPages/Documents/ReceivedDocuments/ReceivedDocuments";
import CompanyDocuments from "./pages/AdminPages/Documents/CompanyDocuments/companyDocuments";
import { toast, Toaster } from "react-hot-toast";
// import GetPlans from "./pages/AdminPages/Upgrade/GetPlans";
// import PaymentSuccess from "./pages/AdminPages/Upgrade/SuccessScreen";
import PaymentSuccess from "./pages/AdminPages/SubscriptionandPlans/SuccessScreen";
import RequestManagement from "./pages/AdminPages/Requests/RequestManagement";
import VerifyInvite from "./pages/AuthPages/Login/VerifyInvite";
import InviteResetPassword from "./pages/AuthPages/Login/InviteResetPassword";
import Payroll from "./pages/AdminPages/ExpenseManagement/Payroll/Payroll";
import AttendanceSettings from "./pages/AdminPages/Attendance/AttendanceSettings/AttendanceSettings";
import ReimbursementRequest from "./pages/AdminPages/ExpenseManagement/ReimbursementRequest/ReimbursementRequest";
import ReceivedDocumentsTable from "./pages/AdminPages/Documents/ReceivedDocuments/ReceivedDocuments";
import ScrollToTop from "./components/ScrollToTop";
import LocatingPill from "./components/LocatingPill";
import { useEffect, useState } from "react";
import AdminApproval from "./pages/AuthPages/Login/AdminApprovalModal";
import InvalidOtpErrorScreen from "./pages/AuthPages/Registeration/InvalidOtpErrorScreen";
import LoginPassword from "./pages/AuthPages/Login/LoginPassword";
import SubscriptionAndPlans from "./pages/AdminPages/SubscriptionandPlans/subscriptionPlans";
import i18n from './i18n';
import DepartmentDetail from "./pages/AdminPages/Worker/Departments/DepartmentDetail";
import SubscriptionSuccess from "./pages/AdminPages/SubscriptionandPlans/SubscriptionSuccess";
import RevisedSuccess from "./pages/AdminPages/SubscriptionandPlans/RevisedSuccess";
import ApproveMethod from "./pages/AdminPages/SubscriptionandPlans/ApproveMethod";
import Absence from "./pages/AdminPages/Absence/Absence";
import Suppliers from "./pages/AdminPages/Suppliers/Suppliers";
import Vacancies from "./pages/AdminPages/Vancancies/Vancancies";
  import Applicants from "./pages/AdminPages/Applicants/Applicants";
  import AutomatedDocuments from "./pages/AdminPages/Documents/AutomatedDocuments/AutomatedDocuments";
  import RegisterRoute from "./pages/AuthPages/Registeration/RegisterRoute";
  import { useJsApiLoader } from "@react-google-maps/api";
import { MAPS_API_KEY } from "./components/mapKey";
import DashboardHeader from "./components/Headers/DashboardHeader";

const SubscriptionRouteLayout = () => {
  const location = useLocation();
  const upgradeToken = new URLSearchParams(location.search).get("upgrade_token");

  return upgradeToken ? (
    <>
      <DashboardHeader minimal upgradeToken={upgradeToken} />
      <Outlet />
    </>
  ) : <DashboardLayout />;
};

function App() {
  const [profile, setProfile] = useState(null);
  const handleProfileUpdate = (updatedProfile) => {
    // Update the profile in state
    setProfile(updatedProfile);
  };

    // Get browser language function
    const getBrowserLanguage = () => {
      const browserLang = navigator.language || navigator.userLanguage;
      console.log('Browser language detected:', browserLang);
      
      // Extract language code (e.g., 'es-ES' -> 'es', 'en-US' -> 'en')
      const langCode = browserLang.split('-')[0].toLowerCase();
      console.log('🌐 Language code:', langCode);
      
      // Map to supported languages
      const supportedLanguages = {
        'es': 'es', // Spanish
        'en': 'en', // English
      };
      
      // Return supported language or default to English
      const detectedLang = supportedLanguages[langCode] || 'en';
      console.log('🌐 Mapped to language:', detectedLang);
      
      return detectedLang;
    };
     
  
    // useEffect(() => {
    //   // Restore auth from localStorage on app load
   
    //   // Auto-detect and set language based on browser language
    //   const savedLang = localStorage.getItem('lang');
    //   // if (!savedLang) {
    //     const detectedLanguage = getBrowserLanguage();
    //     console.log('🌐 Setting language to:', detectedLanguage);
    //     i18n.changeLanguage(detectedLanguage);
    //     localStorage.setItem('lang', detectedLanguage);
    //   // }
    // }, []);
useEffect(() => {
const savedLang = localStorage.getItem("i18nextLng");


if (!savedLang) {
// 👶 First-time user → use browser language
const detectedLanguage = getBrowserLanguage();
console.log("🌍 No saved language, using browser:", detectedLanguage);
i18n.changeLanguage(detectedLanguage);
} else {
// 🔒 Returning user → respect their choice
console.log("🔒 Using saved language:", savedLang);
}
}, []);


const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: MAPS_API_KEY,
  libraries: ["places"],
});

if (!isLoaded) return null;


  return (
    <Router>
      <Toaster />
      <LocatingPill />
      <DynamicThemeProvider>
        <ScrollToTop />

        <Routes>
          <Route path="/payment/success" element={<PaymentSuccess />} />
<Route path="/subscription/success" element={<SubscriptionSuccess />} />
<Route path="/subscription/revision-approved" element={<RevisedSuccess />} />
<Route path="/subscription/revision-cancelled" element={<RevisedSuccess />} />
<Route path="/subscription/payment-method-updated" element={<ApproveMethod/>} />
          <Route
            element={
              <PublicRoute>
                <AuthLayout />
              </PublicRoute>
            }
          >

            <Route path="/" element={<Login />} />
            <Route path="/forget-password" element={<ForgetPassword />} />

            <Route path="/verification" element={<VerificationScreen />} />
            <Route path="/reset-password" element={<ResetPassword />} />

          </Route>
          <Route
            element={
              <PublicRoute>
                <AuthRegisterLayout />
              </PublicRoute>
            }
          >
           {/* <Route path="/register" element={<RegisterRoute />} /> */}
            <Route path='/company-admin/set-password' element={<LoginPassword />} />
            <Route path="/register" element={<Registeration />} />
            <Route path="/admin-approval" element={<AdminApproval />} />
            <Route path="/otp-screen" element={<OTPScreen />} />
            <Route path="/invalid-otp-error" element={<InvalidOtpErrorScreen />} />
            <Route path="/company-admin/verify-invite" element={<VerifyInvite />} />
            <Route path="/set-password" element={<InviteResetPassword />} />
            <Route path="/location" element={<Location />} />
            <Route path="/create-profile" element={<CreateProfile />} />
            <Route path="/region" element={<Region />} />
            <Route path="/face-scanning" element={<FaceScanning />} />
            <Route path="/address-location" element={<AddressLocation />} />
            <Route path="/company-details" element={<CompanyDetails />} />
            <Route
              
              path="/registration-verification"
              element={<RegisterationVerification />}
            />
          </Route>
          <Route element={<SubscriptionRouteLayout />}>
            <Route path="/subscription-plans" element={<SubscriptionAndPlans />} />
          </Route>
          <Route
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >


            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/all-employees" element={<AllWorkers />} />
            <Route path="/messages" element={<MessagesLayout />} />
            <Route path="/messages/super-admin" element={<MessagesLayout />} />
            <Route path="/messages/account-executive" element={<MessagesLayout />} />
            <Route path="/messages/worker" element={<MessagesLayout />} />
            {/* <Route path="/get-plans" element={<GetPlans />} /> */}
             
 <Route path="/absence" element={<Absence />} />
 <Route path="/applicants" element={<Applicants />} />
 <Route path="/suppliers" element={<Suppliers />} />
 <Route path="/vacancies" element={<Vacancies />} />
            <Route path="/support" element={<Support />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/department" element={<Departments />} />
            <Route path="/department-detail/:id" element={<DepartmentDetail />} />
            <Route path="/task-calender" element={<CalendarTask />} />
            <Route path="/all-tasks" element={<AllTasks />} />
            <Route path="/salary-records" element={<SalaryRecords />} />
            <Route path="/reports" element={<Reports />} />
            <Route
              path="/reports-services"
              element={<ReportsandStatistics />}
            />

            <Route path="/Reimbursement-request" element={<ReimbursementRequest />} />
            <Route path="/payroll" element={<Payroll />} />



            <Route path="/todays-logs" element={<TodaysLogs />} />
            <Route
              path="/unvalidated-punches"
              element={<UnvalidatedPunches />}
            />

            <Route path="/attendance-settings" element={<AttendanceSettings />} />
            <Route path="/attendance-history" element={<AttendanceHistory />} />
            <Route path="/task-attendance-history" element={<TaskAttendanceHistory />} />
            <Route path="/request-management" element={<RequestManagement />} />
            <Route path="/worker-documents" element={<ReceivedDocumentsTable />} />
              {/* <Route path="/automated-documents" element={<AutomatedDocuments />} /> */}
            <Route path="/companies-policies" element={<CompanyDocuments />} />
          </Route>
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </DynamicThemeProvider>
    </Router>
  );
}
export default App;
